const drawerPickers = new Set();
const states = new WeakMap();

// Drawer click boundaries must not prevent the picker from closing. Leave the
// library directive unchanged everywhere outside an Admin 2026 drawer.
export function admin2026DrawerDatepickerDirective(legacyDirective) {
    return {
        mounted(el, binding) {
            if (!el.closest('.admin2026-drawer-panel, .admin2026-drawer-surface')) {
                legacyDirective.mounted?.(el, binding);
                return;
            }
            const picker = binding.instance;
            el.setAttribute('data-admin2026-drawer-datepicker', 'true');
            drawerPickers.add(picker);
            const click = (event) => {
                const target = event.target;
                if (!el.contains(target)) {
                    picker.isShow = false;
                    return;
                }
                if (target.closest('.away-cancel-picker, .away-apply-picker')) {
                    picker.isShow = false;
                } else if (target === picker.LitepieInputRef) {
                    picker.isShow = true;
                }
            };
            const keydown = (event) => {
                if (event.key === 'Escape' && picker.isShow) {
                    picker.isShow = false;
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
            };
            const stop = picker.$watch('isShow', (open) => {
                if (!open) return;
                for (const other of drawerPickers) {
                    if (other !== picker) other.isShow = false;
                }
                picker.$nextTick(() => {
                    if (picker.isShow && el.isConnected) {
                        picker.LitepieRef?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
                    }
                });
            });
            document.addEventListener('click', click, true);
            document.addEventListener('keydown', keydown, true);
            states.set(el, { picker, click, keydown, stop });
        },
        updated(el, binding) {
            if (!states.has(el)) legacyDirective.updated?.(el, binding);
        },
        unmounted(el, binding) {
            const state = states.get(el);
            if (!state) {
                legacyDirective.unmounted?.(el, binding);
                return;
            }
            document.removeEventListener('click', state.click, true);
            document.removeEventListener('keydown', state.keydown, true);
            state.stop();
            drawerPickers.delete(state.picker);
            states.delete(el);
        },
    };
}
